import Avatar1 from "@/assets/images/HeroStats/Avatar1.png";
import Avatar2 from "@/assets/images/HeroStats/Avatar2.png";
import Avatar3 from "@/assets/images/HeroStats/Avatar3.png";
import OtherOfferingCourses from "@/assets/images/OtherOfferings/products-courses.svg";
import OtherOfferingDigitalProduct from "@/assets/images/OtherOfferings/products-digitalproducts.svg";
import OtherOfferingMembership from "@/assets/images/OtherOfferings/products-membership.svg";
import OtherOfferingTelegramCommunity from "@/assets/images/OtherOfferings/products-telegramCommunity.svg";
import OtherOfferingWebinar from "@/assets/images/OtherOfferings/products-webinar.svg";

// HeroBanners Assets:
import BannerCourses from "@/assets/images/Products/HeroBanners/products-courses.png";
import BannerDigitalProduct from "@/assets/images/Products/HeroBanners/products-digitalproducts.png";
import BannerMembership from "@/assets/images/Products/HeroBanners/products-membership.png";
import BannerTelegramCommunity from "@/assets/images/Products/HeroBanners/products-telegram.png";
import BannerWebinar from "@/assets/images/Products/HeroBanners/products-webinar.png";

// InfoAccordion Assets:
import InfoAccordionCoursesStep1 from "@/assets/images/Products/InfoAccordion/courses-1.png";
import InfoAccordionCoursesStep2 from "@/assets/images/Products/InfoAccordion/courses-2.png";
import InfoAccordionCoursesStep3 from "@/assets/images/Products/InfoAccordion/courses-3.png";
import InfoAccordionCoursesStep4 from "@/assets/images/Products/InfoAccordion/courses-4.png";
import trainyouravatar from "@/assets/images/Products/InfoAccordion/trainyouravatar.svg";

import InfoAccordionWebinarStep1 from "@/assets/images/Products/InfoAccordion/webinar-1.png";
import InfoAccordionWebinarStep2 from "@/assets/images/Products/InfoAccordion/webinar-2.png";
import InfoAccordionWebinarStep3 from "@/assets/images/Products/InfoAccordion/webinar-3.png";
import InfoAccordionWebinarStep4 from "@/assets/images/Products/InfoAccordion/webinar-4.png";

import InfoAccordionMembershipStep1 from "@/assets/images/Products/InfoAccordion/membership-1.png";
import InfoAccordionMembershipStep2 from "@/assets/images/Products/InfoAccordion/membership-2.png";
import InfoAccordionMembershipStep3 from "@/assets/images/Products/InfoAccordion/membership-3.png";
import InfoAccordionMembershipStep4 from "@/assets/images/Products/InfoAccordion/membership-4.png";

import InfoAccordionDigitalProductStep1 from "@/assets/images/Products/InfoAccordion/digitalproduct-1.png";
import InfoAccordionDigitalProductStep2 from "@/assets/images/Products/InfoAccordion/digitalproduct-2.png";
import InfoAccordionDigitalProductStep3 from "@/assets/images/Products/InfoAccordion/digitalproduct-3.png";
import InfoAccordionDigitalProductStep4 from "@/assets/images/Products/InfoAccordion/digitalproduct-4.png";

import InfoAccordionTelegramCommunityStep1 from "@/assets/images/Products/InfoAccordion/telegram-1.png";
import InfoAccordionTelegramCommunityStep3 from "@/assets/images/Products/InfoAccordion/telegram-3.png";
import InfoAccordionTelegramCommunityStep4 from "@/assets/images/Products/InfoAccordion/telegram-4.png";
import InfoAccordionTelegramCommunityStep5 from "@/assets/images/Products/InfoAccordion/telegram-5.png";

// ProductFirstSteps assets:
import Step1Courses from "@/assets/images/Products/ProductFirstSteps/courses-1.svg";
import Step2Courses from "@/assets/images/Products/ProductFirstSteps/courses-2.svg";
import Step3Courses from "@/assets/images/Products/ProductFirstSteps/courses-3.svg";

import Step1DigitalProduct from "@/assets/images/Products/ProductFirstSteps/digitalproduct-1.svg";
import Step2DigitalProduct from "@/assets/images/Products/ProductFirstSteps/digitalproduct-2.svg";
import Step3DigitalProduct from "@/assets/images/Products/ProductFirstSteps/digitalproduct-3.svg";

import Step1Membership from "@/assets/images/Products/ProductFirstSteps/membership-1.svg";
import Step2Membership from "@/assets/images/Products/ProductFirstSteps/membership-2.svg";
import Step3Membership from "@/assets/images/Products/ProductFirstSteps/membership-3.svg";

import Step1Webinar from "@/assets/images/Products/ProductFirstSteps/webinar-1.svg";
import Step2Webinar from "@/assets/images/Products/ProductFirstSteps/webinar-2.svg";
import Step3Webinar from "@/assets/images/Products/ProductFirstSteps/webinar-3.svg";

import Step1TelegramCommunity from "@/assets/images/Products/ProductFirstSteps/telegram-1.svg";
import Step2TelegramCommunity from "@/assets/images/Products/ProductFirstSteps/telegram-2.svg";
import Step3TelegramCommunity from "@/assets/images/Products/ProductFirstSteps/telegram-3.svg";

// Graphy Assist:
import GraphyAssistCoursesImage from "@/assets/images/GraphyAssist/graphy-assist-courses.png";

// Marketing Feature:
import MarketingCourseSuccessToolkilImage from "@/assets/images/MarketingFeature/course-success-toolkit.png";
import SupportAndResourcesImage from "@/assets/images/MarketingFeature/support-and-resources.png";

import { FeaturesGridPropsType } from "@/components/Home/FeaturesGrid/FeaturesGrid";
import { graphyAssistPropsType } from "@/components/Home/GraphyAssist";
import { CentreCtaSectionPropType } from "@/components/ProductPage/CentreCtaSection";
import { ProductHeroSectionPropType } from "@/components/ProductPage/ProductHeroSection";
import { ProductStepsSectionPropType } from "@/components/ProductPage/ProductStepsSection";
import { ButtonSizeEnum, ButtonTypeEnum } from "@/components/atoms/Button";
import {
  BookADemoSourceEnum,
  CtaActionType,
  LearnMoreSourceEnum,
  SignUpSourceEnum,
} from "@/components/molecules/CtaButtonGroup";
import { SuccessStoriesMarqueeSectionPropType } from "@/components/organisms/Carousels/SuccessStoriesMarqueeSection";
import { TestimonyCarouselSectionPropType } from "@/components/organisms/Carousels/TestimonyCarouselSection";
import { FaqSectionPropsType } from "@/components/organisms/FaqSection";
import { GraphyHeadPropType } from "@/components/organisms/GraphyHead";
import InfoAccordion, {
  InfoAccProdSecForAmpEnum,
  InfoAccordionProps,
  InfoAccordionTypeEnum,
} from "@/components/organisms/InfoAccordion/InfoAccordion";
import {
  OtherOfferingsMetaDataType,
  OtherOfferingsSectionPropType,
} from "@/components/organisms/OtherOfferingsSection";
import { FeatureProps } from "@/components/templates/LandingPage/Feature";
import { LANDING_PAGE_EVENTS } from "@/constants/amplitude.constants";
import { CtaVisitHelpCentre_en } from "../constants/common.constants";
import {
  OnboardingDestinationEnum,
  ProductPageSlugEnum,
} from "../types/common.types";
import {
  BOOK_A_DEMO_en,
  GET_STARTED_en,
  LEARN_MORE_en,
  START_MONETIZING_en,
} from "./common.data";
import { HeroPillCategoryEnum_en, ProductsEnum_en } from "./hero-pills.data";
import { ROUTE_PATHS } from "./routes";

//ai-avatar
import CardsAiAgent2 from "@/assets/images/Features/Cards/graphy-assist/2.png";
import InfoAccordionaiavatarStep1 from "@/assets/images/Products/InfoAccordion/aiavatars1.png";
import InfoAccordionaiavatarStep2 from "@/assets/images/Products/InfoAccordion/aiavatars2.png";
import InfoAccordionaiavatarStep4 from "@/assets/images/Products/InfoAccordion/aiavatars4.png";
import Aiavatar1 from "@/assets/images/Products/ProductFirstSteps/aiavatar-1.svg";
import alwaysontutor from "@/assets/images/Products/ProductFirstSteps/alwaysontutor.png";
import montizeaccess from "@/assets/images/Products/ProductFirstSteps/montizeaccess.png";
import { getCDNURL } from "../utils/commons";
export type ProductDataType = {
  seoMeta: GraphyHeadPropType;
  otherOfferingsMeta: OtherOfferingsMetaDataType;
  productHeroSectionProps: ProductHeroSectionPropType;
  testimonyCarouselSectionProps: TestimonyCarouselSectionPropType;
  productStepsSectionProps: ProductStepsSectionPropType;
  infoAccordionSection: InfoAccordionProps;
  graphyAssistProps?: graphyAssistPropsType;
  successStoriesMarqueeSectionProps: SuccessStoriesMarqueeSectionPropType;
  faqSectionProps: FaqSectionPropsType;
  featureProps1?: FeatureProps;
  featuresGridProps?: FeaturesGridPropsType;
  centreCtaSectionProps: CentreCtaSectionPropType;
  featureProps2?: FeatureProps;
  centreCtaSectionProps2?: CentreCtaSectionPropType;
};

export const otherProductOfferingsSectionProps_en: OtherOfferingsSectionPropType =
  {
    otherOfferingsMetaData: [],
    title: [
      {
        text: "Check out our other products",
      },
    ],
    gap: "gap-4 sm:gap-9",
  };

const CoursePageData: ProductDataType = {
  seoMeta: {
    title: "Create and sell online courses - Graphy",
    description:
      "Trusted platform to create, market, and sell online courses with integrated payments. Start creating and selling courses for free.",
    canonicalPath: ROUTE_PATHS.PRODUCTS.courses,
    countryCode: "",
  },
  otherOfferingsMeta: {
    name: "Courses",
    description: "Start selling courses in no time",
    image: OtherOfferingCourses,
    slug: ProductPageSlugEnum.courses,
    path: ROUTE_PATHS.PRODUCTS.courses,
  },
  productHeroSectionProps: {
    heroPill: {
      category: HeroPillCategoryEnum_en.Products,
      subCategory: ProductsEnum_en.Courses,
    },
    title: [
      {
        text: "Sell your",
        lineBreak: true,
      },
      {
        text: "Courses",
        highlight: true,
      },
    ],
    description:
      "Build an online course with zero tech skills and give your learners a seamless learning experience",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Create an online course",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.hero,
          },
        },
        queryParams: {
          destination: OnboardingDestinationEnum.Courses,
          skipOnboarding: false,
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.hero,
          },
        },
      },
    ],
    heroStatsProps: {
      text: "250,000+ online courses created",
      avatars: [
        {
          src: Avatar1,
          alt: "avatar1",
        },
        {
          src: Avatar2,
          alt: "avatar2",
        },
        {
          src: Avatar3,
          alt: "avatar3",
        },
      ],
    },
    coverImage: {
      src: BannerCourses,
      alt: "Courses",
    },
  },
  testimonyCarouselSectionProps: {
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  productStepsSectionProps: {
    title: [
      {
        text: "3 easy steps",
        highlight: true,
      },
      {
        text: " to start selling courses",
        highlight: false,
      },
    ],
    description:
      "Use our intuitive tools to design and build an online course that showcase your expertise",
    steps: [
      {
        image: Step1Courses,
        text: "Create course",
        description:
          "Creating & selling courses has never been easier! Engage your audience, customize your brand, and track progress",
      },
      {
        image: Step2Courses,
        text: "Publish course",
        description:
          "Sell online courses & reach learners worldwide, process payments seamlessly, and build a loyal community",
      },
      {
        image: Step3Courses,
        text: "Promote course",
        description:
          "Market strategically, boost visibility, and measure results. Sell online courses like a pro with our intuitive tools!",
      },
    ],
  },
  infoAccordionSection: {
    title: [
      {
        text: "Sell online courses seamlessly",
      },
    ],
    amplitudeEvent: {
      eventName: LANDING_PAGE_EVENTS.PRODUCT_FEATURE_DETAIL_EXPANDED.LABEL,
    },
    section: InfoAccProdSecForAmpEnum.Courses,
    cta: {
      type: ButtonTypeEnum.Secondary,
      size: ButtonSizeEnum.Regular,
      text: "Build an online course",
      actionType: CtaActionType.SignUp,
      amplitudeEvent: {
        eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
        eventProperties: {
          source: SignUpSourceEnum.products_section,
        },
      },
      queryParams: {
        destination: OnboardingDestinationEnum.Courses,
        skipOnboarding: false,
      },
    },
    data: [
      {
        title: "AI-assisted course generation",
        description:
          "Creating and selling courses online has never been more efficient thanks to our AI-assisted course generation feature. Our AI algorithms suggest course content, structure, and even create meta tags for SEO. With AI assistance, you can effortlessly sell courses online that are tailored to meet the needs of your learners.",
        image: {
          src: InfoAccordionCoursesStep1,
          alt: "Courses",
        },
      },
      {
        title: "Rich multimedia course content",
        description:
          "To stand out and sell courses online successfully, you need more than just text and images. Use a wide range of content options, such as text, images, videos, audio files, MP3s, links, PDFs, quizzes, sessions, and various other formats.",
        image: {
          src: InfoAccordionCoursesStep2,
          alt: "Courses",
        },
      },
      {
        title: "Self-paced or instructor-led",
        description:
          "Teach tens, hundreds or thousands, we’ve got you covered. Control the flow of your course content — allow learners to access whole content at once, or restrict the navigation piece by piece. Sell courses online in your preferred format just the way you like.",
        image: {
          src: InfoAccordionCoursesStep3,
          alt: "Courses",
        },
      },
      {
        title: "Award certificates",
        description:
          "Boost your credibility and motivate your learners by offering certificates upon course completion. Create and distribute personalized certificates to your students. Leverage certificates to attract more learners and increase your success in selling courses online.",
        image: {
          src: InfoAccordionCoursesStep4,
          alt: "Courses",
        },
      },
    ],
    type: InfoAccordionTypeEnum.MediaFirst,
  },
  graphyAssistProps: {
    title: [
      {
        text: "AI Course Builder:",
        lineBreak: true,
      },
      {
        text: " Empowering Creators",
        highlight: true,
        customHighlightClass: "text-green-3",
      },
    ],
    description:
      "Experience the future of online course creation with our AI Course Builder",
    features: [
      "Instantly generate content: AI crafts captivating course descriptions, metadata, and even course content snippets, saving you time and effort when you sell courses online.",
      "Optimize effortlessly: AI analyzes data to suggest content and structure, ensuring your success in selling courses online.",
      "Effortless scaling: Easily create a portfolio of courses in record time. Sell courses online across a wide range of topics and expand your earning potential.",
    ],
    image: {
      src: GraphyAssistCoursesImage,
      alt: "Graphy Assist Courses",
    },
    ctas: [
      {
        type: ButtonTypeEnum.Gradient,
        size: ButtonSizeEnum.Regular,
        text: "Start now",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.assist_section,
          },
        },
      },
    ],
  },
  successStoriesMarqueeSectionProps: {
    title: [
      {
        text: "Success Stories of Our Partners",
      },
    ],
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  faqSectionProps: {
    title: "FAQs",
    description:
      "Explore our help center for detailed information on selling courses, troubleshooting guides, and more",
    cta: CtaVisitHelpCentre_en,
    faqs: [
      {
        question:
          "Can I offer certificates of completion for my Graphy courses?",
        answer:
          "Absolutely! You can reward your students with custom certificates upon course completion when you sell courses online with Graphy. Certificates add value to your courses and motivate learners to succeed.",
      },
      {
        question:
          "Is there a limit to the number of courses I can create with the Graphy Course Creator?",
        answer: "No, you can create unlimited online courses on Graphy",
      },
      {
        question:
          "Can I offer discounts or promotions for my Graphy courses when I sell courses online?",
        answer:
          "Yes, Graphy provides the flexibility to offer discounts or run promotions for your courses. You can attract more students, boost enrollment, and tailor your pricing.",
      },
      {
        question: "How can I start to sell courses online with Graphy?",
        answer:
          "To sell courses online through Graphy, simply build your course, publish it on our platform, and then promote it to reach your target audience. Our user-friendly tools make it easy to share your expertise and generate revenue by selling courses online.",
      },
      {
        question: "Can I have multiple instructors within one course",
        answer:
          "Yes, Graphy supports multiple instructors to be a part of the course. It also offers the flexibility to switch between self-paced and instructor-led courses as you see fit when selling courses online. Adapt your teaching style to cater to a wide range of learner preferences.",
      },
      {
        question:
          "Can I customize my course page to match my branding while selling courses online?",
        answer:
          "Absolutely! You can personalize your course page on Graphy to reflect your unique branding and style. It's a great way to create a professional and memorable online presence while selling courses online.",
      },
      {
        question:
          "Is there a limit to how many courses I can sell online using Graphy Course Creator?",
        answer:
          "No, there is no limit! You can create and sell as many courses online as you like on the Graphy platform. We're here to support your journey to sell courses online and expand your online teaching empire.",
      },
      {
        question:
          "How can I get support if I encounter challenges while selling courses online with Graphy?",
        answer:
          "Graphy provides dedicated support to assist you with any challenges you may encounter while selling courses online. Our support team is readily available to answer your questions and help you navigate your online teaching journey with confidence.",
      },
      {
        question:
          "How secure is the payment processing when I sell courses online through Graphy?",
        answer:
          "Graphy ensures secure and reliable payment processing for your online courses. You can focus on creating and delivering exceptional content while we handle the financial transactions with the utmost security.",
      },
    ],
  },
  featureProps1: {
    data: {
      type: "feature",
      id: "1",
      nextImage: {
        src: MarketingCourseSuccessToolkilImage,
        alt: "Course Success Toolkit",
      },
      title: "Your online course success toolkit",
      description:
        "Everything you need to successfully sell courses online and give your learners a seamless learning experience.",
      ctaText: "Schedule a demo",
      ctaType: "schedule-demo",
      gradientColor: "aurora2",
      width: "800",
      height: "700",
      highlights: [
        {
          title: "Seamless course creation",
          description:
            "Graphy simplifies the process of creating and selling courses online. Our user-friendly interface and AI-powered tools empower you to craft courses effortlessly. Whether you're an experienced instructor or just starting, we provide the tools you need to succeed in selling courses online.",
        },
        {
          title: "Amplify your course's reach",
          description:
            "Selling courses online requires a broad reach, and Graphy has you covered. We offer powerful marketing insights and smart tools to boost your course's visibility. Connect with a global audience, so you can reach learners far and wide.",
        },
        {
          title: "Tailor your courses to your style",
          description:
            "Graphy understands that every instructor has a unique teaching style. Whether you prefer self-paced learning or active instructor-led engagement, we give you the flexibility to sell courses online in the way that suits you best.",
        },
        {
          title: "Interactive content",
          description:
            "Engage learners with interactive elements like quizzes, assignments, and multimedia. Enhance the learning experience by promoting active participation.",
        },
      ],
    },
  },
  featuresGridProps: {
    title: [
      {
        text: "Powerful",
      },
      {
        text: " features",
        highlight: true,
      },
      {
        text: " to",
        lineBreak: true,
      },
      {
        text: "fuel your success",
      },
    ],
    featureCards: [
      {
        title: "Website",
        description:
          "Get your hands on a stunning website that you can leverage to sell courses online",
        image: "/images/features/website.svg",
        link: ROUTE_PATHS.FEATURES.WebsiteBuilder,
        classes: "md:col-span-6 lg:col-span-4",
      },
      {
        title: "Mobile app",
        description:
          "Flaunt your brand with our no-code tools and get your own app for selling courses",
        image: "/images/features/mobile-app.svg",
        link: ROUTE_PATHS.FEATURES.MobileApp,
        classes: "md:col-span-4 lg:col-span-3",
      },
      {
        title: "Community",
        description:
          "Behind every successful course is a loyal community that loves to learn, grow & engage with each other",
        image: "/images/features/community.svg",
        mwebImage: "/images/features/community-mweb.svg",
        link: ROUTE_PATHS.FEATURES.ChatCommunity,
        classes: "md:col-span-6 lg:col-span-3",
      },
      {
        title: "Marketing tools",
        description:
          "Capture more leads and effortlessly sell courses online with inbuilt automation",
        link: ROUTE_PATHS.FEATURES.MarketingTools,
        image: "/images/features/marketing.svg",
        classes: "md:col-span-6 lg:col-span-3",
      },
      {
        title: "Third party integrations",
        description:
          "Connect unlimited tools for maximum flexibility to your creator platform with built-in integration",
        link: ROUTE_PATHS.FEATURES.ThirdPartySupport,
        image: "/images/features/third-party.svg",
        classes: "md:col-span-4 lg:col-span-4",
      },
      {
        title: "Payment gateways",
        description:
          "Sell courses online to learners worldwide and accept payments locally & internationally",
        link: ROUTE_PATHS.FEATURES.IntegratePaymentGateway,
        image: "/images/features/pg.svg",
        classes: "md:col-span-4 lg:col-span-3",
      },
      {
        title: "AI Avatar",
        description:
          "Create AI agents that acquire new customers, provide instant support to your community, and deliver personalized coaching at scale",
        link: ROUTE_PATHS.PRODUCTS.aiavatar,
        image: "/images/features/graphy-AiAvatar.svg",
        classes: "md:col-span-6 lg:col-span-3",
      },
    ],
  },
  centreCtaSectionProps: {
    maxWidth: "max-w-[720px]",
    title: [
      {
        text: "Let's create your",
        highlight: false,
      },
      {
        text: " first course",
        highlight: true,
      },
    ],
    description:
      "100K+ creators trust our all-in-one platform for effortlessly creating and selling courses. Join us today!",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Create now",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.body_end,
          },
        },
        queryParams: {
          destination: OnboardingDestinationEnum.Courses,
          skipOnboarding: false,
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.bodyEnd,
          },
        },
      },
    ],
  },
  featureProps2: {
    data: {
      type: "feature",
      id: "2",
      nextImage: {
        src: SupportAndResourcesImage,
        alt: "Support and resources",
      },
      title: "Support and resources for course creators",
      description:
        "Access a wealth of resources and tools, tailored to help you succeed. Whether you're a seasoned educator or just starting, our comprehensive toolkit can fuel your success.",
      ctaText: "Schedule a demo",
      ctaType: "schedule-demo",
      gradientColor: "aurora2",
      width: "800",
      height: "700",
      highlights: [
        {
          title: "Support and community",
          description:
            "Graphy doesn't just provide a platform; we offer a supportive community. Our team is dedicated to helping you throughout your journey to sell courses online. Plus, you can connect with like-minded instructors in our thriving community.",
        },
        {
          title: "Analytics and insights",
          description:
            "To improve and sell courses online effectively, you need data-driven insights. Graphy offers comprehensive analytics, allowing you to track your course's performance and make informed decisions for optimization.",
        },
        {
          title: "Secure payment processing",
          description:
            "Selling courses online involves financial transactions, and we take security seriously. Graphy ensures secure and reliable payment processing, so you can focus on what you do best – creating and delivering exceptional content.",
        },
        {
          title: "Comprehensive marketing tools",
          description:
            "Access a suite of marketing tools designed to help you sell online courses effectively. Utilize affiliate marketing, webinars, and blog marketing features to reach your target audience.",
        },
      ],
    },
  },
  // centreCtaSectionProps2: {
  //   gradient: true,
  //   title: [
  //     {
  //       text: "We've got your migration covered",
  //       highlight: false,
  //     },
  //   ],
  //   description: [
  //     {
  //       text: "We offer FREE customer support to help you migrate your courses, landing pages, data, and operations for annual plan customers.",
  //     },
  //   ],
  //   ctas: [
  //     {
  //       type: ButtonTypeEnum.Primary,
  //       size: ButtonSizeEnum.Regular,
  //       text: "Create now",
  //       actionType: CtaActionType.SignUp,
  //       amplitudeEvent: {
  //         eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
  //         eventProperties: {
  //           source: SignUpSourceEnum.body_end,
  //         },
  //       },
  //       queryParams: {
  //         destination: OnboardingDestinationEnum.Courses,
  //         skipOnboarding: false,
  //       },
  //     },
  //     {
  //       type: ButtonTypeEnum.Secondary,
  //       size: ButtonSizeEnum.Regular,
  //       text: "Book a demo",
  //       actionType: CtaActionType.BookDemo,
  //       amplitudeEvent: {
  //         eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
  //         eventProperties: {
  //           source: BookADemoSourceEnum.bodyEnd,
  //         },
  //       },
  //     },
  //   ],
  // },
};

const WebinarPageData: ProductDataType = {
  seoMeta: {
    title: "Host live webinars with payments - Graphy",
    description:
      "Industry leading platform to conduct live webinars online with integrated payments. Organise a webinar for free.",
    canonicalPath: ROUTE_PATHS.PRODUCTS.webinar,
    countryCode: "",
  },
  otherOfferingsMeta: {
    name: "Webinars",
    description: "Host dynamic live sessions that foster real-time interaction",
    image: OtherOfferingWebinar,
    slug: ProductPageSlugEnum.webinar,
    path: ROUTE_PATHS.PRODUCTS.webinar,
  },
  productHeroSectionProps: {
    heroPill: {
      category: HeroPillCategoryEnum_en.Products,
      subCategory: ProductsEnum_en.Webinars,
    },
    title: [
      {
        text: "Monetize your",
        lineBreak: true,
      },
      {
        text: "Webinars",
        highlight: true,
      },
    ],
    description:
      "Host webinars and workshops seamlessly, allowing your audience to conveniently pay and register at one place",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Host a webinar",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.hero,
          },
        },
        queryParams: {
          destination: OnboardingDestinationEnum.Webinars,
          skipOnboarding: false,
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.hero,
          },
        },
      },
    ],
    heroStatsProps: {
      text: "55,000+ webinars hosted",
      avatars: [
        {
          src: Avatar1,
          alt: "avatar1",
        },
        {
          src: Avatar2,
          alt: "avatar2",
        },
        {
          src: Avatar3,
          alt: "avatar3",
        },
      ],
    },
    coverImage: {
      src: BannerWebinar,
      alt: "Webinar Banner",
    },
  },
  testimonyCarouselSectionProps: {
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  productStepsSectionProps: {
    title: [
      {
        text: "3 easy steps",
        highlight: true,
      },
      {
        text: " to get you going",
        highlight: false,
      },
    ],
    description:
      "Set up a live session within minutes and grow your audience base like never before",
    steps: [
      {
        image: Step1Webinar,
        text: "Schedule a webinar",
      },
      {
        image: Step2Webinar,
        text: "Invite your audience",
      },
      {
        image: Step3Webinar,
        text: "Go live",
      },
    ],
  },
  infoAccordionSection: {
    title: [
      {
        text: "Connect, educate & grow ",
      },
    ],
    amplitudeEvent: {
      eventName: LANDING_PAGE_EVENTS.PRODUCT_FEATURE_DETAIL_EXPANDED.LABEL,
    },
    section: InfoAccProdSecForAmpEnum.Webinars,
    cta: {
      type: ButtonTypeEnum.Secondary,
      size: ButtonSizeEnum.Regular,
      text: "Create webinar",
      actionType: CtaActionType.SignUp,
      amplitudeEvent: {
        eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
        eventProperties: {
          source: SignUpSourceEnum.products_section,
        },
      },
      queryParams: {
        destination: OnboardingDestinationEnum.Webinars,
        skipOnboarding: false,
      },
    },
    data: [
      {
        title: "Enhanced engagement",
        description:
          "Encourage active participation through live Q&A sessions, Polls, Surveys and more",
        image: {
          src: InfoAccordionWebinarStep1,
          alt: "Courses",
        },
      },
      {
        title: "Expand your reach and impact",
        description:
          "Connect with a global audience without geographical limitations",
        image: {
          src: InfoAccordionWebinarStep2,
          alt: "Courses",
        },
      },
      {
        title: "Immersive learning experiences",
        description:
          "Deliver impactful visual presentations with multimedia integration, screen sharing, whiteboarding features",
        image: {
          src: InfoAccordionWebinarStep3,
          alt: "Courses",
        },
      },
      {
        title: "Data-driven insights & analytics",
        description:
          "Track attendance, duration, and participation rates for each webinar",
        image: {
          src: InfoAccordionWebinarStep4,
          alt: "Courses",
        },
      },
    ],
    type: InfoAccordionTypeEnum.MediaFirst,
  },
  successStoriesMarqueeSectionProps: {
    title: [
      {
        text: "Success Stories of Our Partners",
      },
    ],
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  faqSectionProps: {
    title: "FAQs",
    description:
      "Explore our help center for detailed information, troubleshooting guides, and more",
    cta: CtaVisitHelpCentre_en,
    faqs: [
      {
        question: "Can I sell paid webinars on Graphy?",
        answer: "Yes, we provide an option to sell paid webinars on Graphy",
      },
      {
        question: "Do you provide recordings for webinars as well?",
        answer:
          "Yes, you can choose to send webinar recordings to learners too",
      },
      {
        question: "Can I add a limit to the number of webinars I want to sell?",
        answer: "Yes, we have support for batch limit in webinars",
      },
      {
        question: "Where will the webinars be conducted?",
        answer: "All webinars happen on our internal 'Graphy live' platform",
      },
      {
        question:
          "Is there a limit on the total number of webinars I can create?",
        answer:
          "No, you can host unlimited webinars. However, you can only host one concurrent webinar. You can increase this limit by purchasing our annual plan.",
      },
    ],
  },
  centreCtaSectionProps: {
    title: [
      {
        text: "Let's host your",
        highlight: false,
      },
      {
        text: " first webinar",
        highlight: true,
      },
    ],
    description:
      "Gain a competitive edge and host your own webinar, paving the way for your success.",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Host now",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.body_end,
          },
        },
        queryParams: {
          destination: OnboardingDestinationEnum.Webinars,
          skipOnboarding: false,
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.bodyEnd,
          },
        },
      },
    ],
  },
};

const MembershipPageData: ProductDataType = {
  seoMeta: {
    title: "Launch membership online - Graphy",
    description:
      "Host a members only club - receive payments, engage members and monetise your audience. Create a membership now.",
    canonicalPath: ROUTE_PATHS.PRODUCTS.membership,
    countryCode: "",
  },
  otherOfferingsMeta: {
    name: "Memberships",
    description:
      "Launch your membership site within minutes and run it your way",
    image: OtherOfferingMembership,
    slug: ProductPageSlugEnum.membership,
    path: ROUTE_PATHS.PRODUCTS.membership,
  },
  productHeroSectionProps: {
    heroPill: {
      category: HeroPillCategoryEnum_en.Products,
      subCategory: ProductsEnum_en.Membership,
    },
    title: [
      {
        text: "Manage your",
        lineBreak: true,
      },
      {
        text: "Membership",
        highlight: true,
      },
    ],
    description:
      "Ignite your fanbase, unlock recurring revenue. Create your membership site now!",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Get started",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.hero,
          },
        },
        queryParams: {
          destination: OnboardingDestinationEnum.Memberships,
          skipOnboarding: false,
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.hero,
          },
        },
      },
    ],
    heroStatsProps: {
      text: "10,000+ members enrolled",
      avatars: [
        {
          src: Avatar1,
          alt: "avatar1",
        },
        {
          src: Avatar2,
          alt: "avatar2",
        },
        {
          src: Avatar3,
          alt: "avatar3",
        },
      ],
    },
    coverImage: {
      src: BannerMembership,
      alt: "Membership Banner",
    },
  },
  testimonyCarouselSectionProps: {
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  productStepsSectionProps: {
    title: [
      {
        text: "3 easy steps",
        highlight: true,
      },
      {
        text: " to get you going",
        highlight: false,
      },
    ],
    description:
      "Unlock exclusive content with our intuitive tools and create a revenue source that you can rely on",
    steps: [
      {
        image: Step1Membership,
        text: "Create exclusive content",
      },
      {
        image: Step2Membership,
        text: "Launch an invite",
      },
      {
        image: Step3Membership,
        text: "Group chat",
      },
    ],
  },
  infoAccordionSection: {
    title: [
      {
        text: "Unlock the potential of membership",
      },
    ],
    cta: {
      type: ButtonTypeEnum.Secondary,
      size: ButtonSizeEnum.Regular,
      text: "Create membership",
      actionType: CtaActionType.SignUp,
      amplitudeEvent: {
        eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
        eventProperties: {
          source: SignUpSourceEnum.products_section,
        },
      },
      queryParams: {
        destination: OnboardingDestinationEnum.Memberships,
        skipOnboarding: false,
      },
    },
    amplitudeEvent: {
      eventName: LANDING_PAGE_EVENTS.PRODUCT_FEATURE_DETAIL_EXPANDED.LABEL,
    },
    section: InfoAccProdSecForAmpEnum.Membership,
    data: [
      {
        title: "Exclusive content",
        description:
          "Create content exclusively for fans who love your work, not for the algorithm.",
        image: {
          src: InfoAccordionMembershipStep1,
          alt: "Courses",
        },
      },
      {
        title: "Launch an invite",
        description: "Run a group chat and nurture long-term relationships.",
        image: {
          src: InfoAccordionMembershipStep2,
          alt: "Courses",
        },
      },
      {
        title: "No constrains of formats",
        description: "Release blogs, newsletters, courses, and a group chat.",
        image: {
          src: InfoAccordionMembershipStep3,
          alt: "Courses",
        },
      },
      {
        title: "Leave the admin work to us",
        description:
          "Payment powerhouses Stripe, Razorpay and Graphy payment gateway help us handle your payments smoothly.",
        image: {
          src: InfoAccordionMembershipStep4,
          alt: "Courses",
        },
      },
    ],
    type: InfoAccordionTypeEnum.MediaFirst,
  },
  successStoriesMarqueeSectionProps: {
    title: [
      {
        text: "Success Stories of Our Partners",
      },
    ],
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  faqSectionProps: {
    title: "FAQs",
    description:
      "Explore our help center for detailed information, troubleshooting guides, and more",
    cta: CtaVisitHelpCentre_en,
    faqs: [
      {
        question: "Can I have different yearly and monthly pricing?",
        answer:
          "Yes, we have support for defining different yearly and monthly pricing",
      },
      {
        question: "Can I interact exclusively with my members somewhere?",
        answer:
          "Yes, new dedicated channels will be created in the community for your members",
      },
      {
        question:
          "Will membership be a one-time purchase or a recurring transaction?",
        answer: "All membership purchases will be one-time transactions",
      },
      {
        question: "Is there a limit on how many paid members can I have?",
        answer:
          "No, there is no limit on the total number of paid members you can have",
      },
      {
        question: "Can I configure reminders for membership renewal?",
        answer:
          "We have inbuilt automations in place that will send reminders to renew membership. You will be able to customise that.",
      },
    ],
  },
  centreCtaSectionProps: {
    title: [
      {
        text: "Let's manage your ",
      },
      {
        text: "Membership",
        highlight: true,
      },
      {
        text: " today",
      },
    ],
    description:
      "Spark your fanbase, unlock recurring revenue. Launch your membership site within minutes!",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Manage now",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.body_end,
          },
        },
        queryParams: {
          destination: OnboardingDestinationEnum.Memberships,
          skipOnboarding: false,
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.bodyEnd,
          },
        },
      },
    ],
  },
};

const DigitalProductPageData: ProductDataType = {
  seoMeta: {
    title: "Sell Digital Products and receive payments - Graphy",
    description:
      "Monetise your ebooks, notes, private links, art and much more. Instant payouts supported. Start selling now.",
    canonicalPath: ROUTE_PATHS.PRODUCTS.digitalProducts,
    countryCode: "",
  },
  otherOfferingsMeta: {
    name: "Digital Products",
    description:
      "Monetize PDFs, ebooks, locked messages, audio, video within minutes",
    image: OtherOfferingDigitalProduct,
    slug: ProductPageSlugEnum.digitalProducts,
    path: ROUTE_PATHS.PRODUCTS.digitalProducts,
  },
  productHeroSectionProps: {
    heroPill: {
      category: HeroPillCategoryEnum_en.Products,
      subCategory: ProductsEnum_en.DigitalProducts,
    },
    title: [
      {
        text: "Sell your ",
        lineBreak: true,
      },
      {
        text: "Digital products",
        highlight: true,
      },
    ],
    description:
      "Get started with your knowledge business, expand your audience, or add a new revenue stream on Graphy",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Start selling",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.hero,
          },
        },
        queryParams: {
          destination: OnboardingDestinationEnum.DigitalProducts,
          skipOnboarding: false,
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.hero,
          },
        },
      },
    ],
    heroStatsProps: {
      text: "150,000+ creators are selling digital products",
      avatars: [
        {
          src: Avatar1,
          alt: "avatar1",
        },
        {
          src: Avatar2,
          alt: "avatar2",
        },
        {
          src: Avatar3,
          alt: "avatar3",
        },
      ],
    },
    coverImage: {
      src: BannerDigitalProduct,
      alt: "Digital Products Banner",
    },
  },
  testimonyCarouselSectionProps: {
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  productStepsSectionProps: {
    title: [
      {
        text: "3 easy steps",
        highlight: true,
      },
      {
        text: " to get you going",
        highlight: false,
      },
    ],
    description:
      "Set up your own digital store with our easy to use platform and start selling within minutes",
    steps: [
      {
        image: Step1DigitalProduct,
        text: "Upload PDF, Image, Video etc",
      },
      {
        image: Step2DigitalProduct,
        text: "Publish content",
      },
      {
        image: Step3DigitalProduct,
        text: "Start selling",
      },
    ],
  },
  infoAccordionSection: {
    title: [
      {
        text: "Share your creativity with Digital Products",
      },
    ],
    amplitudeEvent: {
      eventName: LANDING_PAGE_EVENTS.PRODUCT_FEATURE_DETAIL_EXPANDED.LABEL,
    },
    section: InfoAccProdSecForAmpEnum.DigitalProducts,
    cta: {
      type: ButtonTypeEnum.Secondary,
      size: ButtonSizeEnum.Regular,
      text: "Create digital product",
      actionType: CtaActionType.SignUp,
      amplitudeEvent: {
        eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
        eventProperties: {
          source: SignUpSourceEnum.products_section,
        },
      },
      queryParams: {
        destination: OnboardingDestinationEnum.DigitalProducts,
        skipOnboarding: false,
      },
    },
    data: [
      {
        title: "Support for multiple file types",
        description:
          "Upload and sell PDFs, e-books, images, videos, links or any other document type.",
        image: {
          src: InfoAccordionDigitalProductStep1,
          alt: "Courses",
        },
      },
      {
        title: "Streamlined payments",
        description:
          "Receive payments faster with industry leading integrations. Supports all the premiere payment methods.",
        image: {
          src: InfoAccordionDigitalProductStep2,
          alt: "Courses",
        },
      },
      {
        title: "Get control of your audience",
        description:
          "Manage your users using our in-house tools. Engage with them over chat and send them emails and notifications.",
        image: {
          src: InfoAccordionDigitalProductStep3,
          alt: "Courses",
        },
      },
      {
        title: "Automated communications",
        description:
          "You focus on the content, we hande the rest. Stop worrying about keeping your audience updated.",
        image: {
          src: InfoAccordionDigitalProductStep4,
          alt: "Courses",
        },
      },
    ],
    type: InfoAccordionTypeEnum.MediaFirst,
  },
  successStoriesMarqueeSectionProps: {
    title: [
      {
        text: "Success Stories of Our Partners",
      },
    ],
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  faqSectionProps: {
    title: "FAQs",
    description:
      "Explore our help center for detailed information, troubleshooting guides, and more",
    cta: CtaVisitHelpCentre_en,
    faqs: [
      {
        question: "Can I sell a digital product for free?",
        answer: "Yes, you can sell a digital product of your choice for free",
      },
      {
        question: "Can I upload a zip file and sell?",
        answer: "Yes, zip files are supported in digital products",
      },
      {
        question: "Can I sell links on Graphy?",
        answer:
          "Yes, you can select link as a product type on digital products",
      },
      {
        question:
          "Is there a limit on the total number of digital products I can sell?",
        answer:
          "No there is no limit on total number of digital products you can sell",
      },
      {
        question:
          "Is there a size limit on the files I can upload in digital products? ",
        answer:
          "Yes, you can only upload upto 200MBs. If you want to sell a file of greater size, you can host it on a server of your choice and mention the link to it",
      },
    ],
  },
  centreCtaSectionProps: {
    title: [
      {
        text: "Let's create your ",
        highlight: false,
      },
      {
        text: "first Digital Product",
        highlight: true,
      },
    ],
    description:
      "Start your knowledge business, reach more people, and generate additional income with Graphy.",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Create now",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.body_end,
          },
        },
        queryParams: {
          destination: OnboardingDestinationEnum.DigitalProducts,
          skipOnboarding: false,
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.body_end,
          },
        },
      },
    ],
  },
};

const TelegramCommunityPageData: ProductDataType = {
  seoMeta: {
    title: "Monetize your Telegram communities - Graphy",
    description:
      "Create a paid Telegram channel and automatically manage members with Graphy.",
    canonicalPath: ROUTE_PATHS.PRODUCTS.telegramCommunity,
    countryCode: "",
  },
  otherOfferingsMeta: {
    name: "Telegram Communities",
    description: "Start monetizing your Telegram communities",
    image: OtherOfferingTelegramCommunity,
    slug: ProductPageSlugEnum.telegramCommunity,
    path: ROUTE_PATHS.PRODUCTS.telegramCommunity,
  },
  productHeroSectionProps: {
    heroPill: {
      category: HeroPillCategoryEnum_en.Products,
      subCategory: ProductsEnum_en.TelegramCommunity,
    },
    title: [
      {
        text: "Monetize your",
        lineBreak: true,
      },
      {
        text: "Telegram Community",
        highlight: true,
      },
    ],
    description:
      "Get started with Graphy's innovative Telegram Subscription Management to effortlessly manage your Telegram subscriptions and payments with automated controls and real-time payments.",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: START_MONETIZING_en,
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.hero,
          },
        },
        queryParams: {
          destination: OnboardingDestinationEnum.TelegramCommunity,
          skipOnboarding: false,
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: BOOK_A_DEMO_en,
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.hero,
          },
        },
        utmFields: {
          utm_medium: "telegram_leads",
        },
      },
    ],
    heroStatsProps: {
      text: "250,000+ creators monetize using Graphy",
      avatars: [
        {
          src: Avatar1,
          alt: "avatar1",
        },
        {
          src: Avatar2,
          alt: "avatar2",
        },
        {
          src: Avatar3,
          alt: "avatar3",
        },
      ],
    },
    coverImage: {
      src: BannerTelegramCommunity,
      alt: "Telegram Banner",
    },
  },
  testimonyCarouselSectionProps: {
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  productStepsSectionProps: {
    title: [
      {
        text: "3 easy steps",
        highlight: true,
      },
      {
        text: " to get you going",
        highlight: false,
      },
    ],
    description:
      "Set up a paid Telegram community within minutes and grow your audience base like never before",
    steps: [
      {
        image: Step1TelegramCommunity,
        text: "Launch your Telegram community",
        description:
          "Link your existing community channel or create a new Telegram community by creating a new group or channel.",
      },
      {
        image: Step2TelegramCommunity,
        text: "Add subscription/pricing",
        description:
          "Choose your subscription tiers from monthly, quarterly, semi-annually, and annually that best suits your audience and the value you provide.",
      },
      {
        image: Step3TelegramCommunity,
        text: "Start monetizing",
        description:
          "Share exclusive content, engage with your subscribers, and enjoy a steady stream of income as your community members become loyal subscribers.",
      },
    ],
  },
  infoAccordionSection: {
    title: [
      {
        text: "Simplify Telegram subscriptions",
      },
    ],
    amplitudeEvent: {
      eventName: LANDING_PAGE_EVENTS.PRODUCT_FEATURE_DETAIL_EXPANDED.LABEL,
    },
    section: InfoAccProdSecForAmpEnum.Webinars,
    cta: {
      type: ButtonTypeEnum.Secondary,
      size: ButtonSizeEnum.Regular,
      text: GET_STARTED_en,
      actionType: CtaActionType.SignUp,
      amplitudeEvent: {
        eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
        eventProperties: {
          source: SignUpSourceEnum.products_section,
        },
      },
      queryParams: {
        destination: OnboardingDestinationEnum.TelegramCommunity,
        skipOnboarding: false,
      },
    },
    data: [
      {
        title: "Automated communication",
        description:
          "Effortlessly manage telegram communities and focus on creating remarkable content that your audience loves. No more juggling spreadsheets or chasing down payments - our automated payment reminders take care of that for you.",
        image: {
          src: InfoAccordionTelegramCommunityStep1,
          alt: "InfoAccordionTelegramCommunityStep1",
        },
      },
      // {
      //   title: "Keep what you earn",
      //   description:
      //     "At Graphy, we're all about creators. That's why we take 0% of your hard-earned revenue. We believe that what you earn should stay with you. Keep 100% of your subscription revenue and maximize your profits.",
      //   image: {
      //     src: InfoAccordionTelegramCommunityStep2,
      //     alt: "InfoAccordionTelegramCommunityStep2",
      //   },
      // },
      {
        title: "Real-Time Settlements",
        description:
          "Graphy offers real-time settlements, ensuring your earnings are instantly accessible. Manage your telegram community by offering country-specific pricing options and letting your audience enjoy your content at prices that make sense for them.",
        image: {
          src: InfoAccordionTelegramCommunityStep3,
          alt: "InfoAccordionTelegramCommunityStep3",
        },
      },
      {
        title: "Audience insights",
        description:
          "Transparency is our commitment to you. Gain insights into user behavior, traffic, and transaction data. Access detailed analytics to refine your strategies and enhance the user experience while effectively managing Telegram communities.",
        image: {
          src: InfoAccordionTelegramCommunityStep4,
          alt: "InfoAccordionTelegramCommunityStep4",
        },
      },
      {
        title: "Scale Your Business",
        description:
          "Creating more than just content? Whether it's courses, webinars, memberships, or any other form of digital magic, Graphy supports it all. Our platform is designed to grow with you, offering the flexibility and resources needed to expand your creativity.",
        image: {
          src: InfoAccordionTelegramCommunityStep5,
          alt: "InfoAccordionTelegramCommunityStep5",
        },
      },
    ],
    type: InfoAccordionTypeEnum.MediaFirst,
  },
  successStoriesMarqueeSectionProps: {
    title: [
      {
        text: "Success Stories of Our Partners",
      },
    ],
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  faqSectionProps: {
    title: "FAQs",
    description:
      "Explore our help center for detailed information on Telegram subscription management, communities, troubleshooting guides, and more.",
    cta: CtaVisitHelpCentre_en,
    faqs: [
      {
        question: "What is Graphy's Telegram Subscription Management feature?",
        answer:
          "Graphy's Telegram Subscription Management is a powerful tool designed to help content creators manage their subscriptions and payments seamlessly on the Telegram platform. It ensures that you can focus on creating content while we handle the administrative aspects of your business.",
      },
      {
        question: "How do automated payment reminders work?",
        answer:
          "Automated payment reminders are a feature of Graphy's Telegram Subscription Management that sends gentle reminders to your subscribers when their payments are due. This reduces the hassle of chasing down payments and keeps your revenue flowing.",
      },
      {
        question: "What does '0% revenue share' mean?",
        answer:
          "It means that Graphy does not take any percentage of your earnings. You keep 100% of your revenue, and we believe in empowering creators to maximize their financial rewards.",
      },
      {
        question:
          "How quickly do I receive payments with real-time settlements?",
        answer:
          "With real-time settlements, your earnings are accessible almost instantly. Say goodbye to waiting for lengthy payout cycles; Graphy puts your money in your hands as soon as it's earned.",
      },
      {
        question: "Can I tailor subscription pricing for different countries?",
        answer:
          "Absolutely! Graphy supports country-specific pricing, allowing you to set subscription fees that make sense for your global audience. This flexibility helps you reach and engage with subscribers from around the world.",
      },
      {
        question: "How does Graphy ensure transparency in content management?",
        answer:
          "We provide complete transparency by offering detailed data on your users, traffic, and transactions. You'll have access to valuable insights that can help you make informed decisions about your content and audience engagement.",
      },
      {
        question:
          "What types of products does Graphy support for scaling businesses?",
        answer:
          "Graphy is versatile and supports a wide range of content types, including courses, webinars, memberships, and much more. Our platform is designed to grow with your creative vision, offering the tools and resources you need to expand your content empire.",
      },
      {
        question:
          "How do I get started with Graphy's Telegram Subscription Management?",
        answer:
          "Getting started is easy! Simply sign up with Graphy, set up your account, and you'll have access to our Telegram Subscription Management feature. We'll guide you through the process to ensure you have a smooth start to your content creation journey.",
      },
      {
        question:
          "Is there a fee for using Graphy's Telegram Subscription Management feature?",
        answer:
          "Graphy offers a range of plans to suit different needs, including a free plan. You can choose the plan that fits your requirements, and there is no additional fee for using our Telegram Subscription Management feature within your plan.",
      },
      {
        question:
          "Can I get personalized support if I have questions or encounter issues?",
        answer:
          "Yes, we have a dedicated support team ready to assist you. If you have questions or encounter any issues while using Graphy, feel free to reach out to our support team for prompt assistance.",
      },
    ],
  },
  centreCtaSectionProps: {
    title: [
      {
        text: "Start monetizing",
        highlight: false,
      },
      {
        text: " your Telegram community",
        highlight: true,
      },
    ],
    description:
      "Are you ready to take your Telegram community to new heights and monetize your passion? Join countless creators, business owners, and community managers who have already found success with our powerful Telegram Subscription Management.",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: GET_STARTED_en,
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.body_end,
          },
        },
        queryParams: {
          destination: OnboardingDestinationEnum.TelegramCommunity,
          skipOnboarding: false,
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.bodyEnd,
          },
        },
        utmFields: {
          utm_medium: "telegram_leads",
        },
      },
    ],
  },
};

const AiAvatar: ProductDataType = {
  seoMeta: {
    title: "Monetize your Mind with AI",
    description:
      "Turn your knowledge into 24/7 tutoring with AI Avatar. Engage learners, grow completions, and monetize access with flexible pricing",
    canonicalPath: ROUTE_PATHS.PRODUCTS.aiavatar,
    countryCode: "",
  },
  otherOfferingsMeta: {
    name: "AI Avatar",
    description: "Sell, engage and support with AI Avatar",
    image: Aiavatar1,
    slug: ProductPageSlugEnum.aiavatar,
    path: ROUTE_PATHS.PRODUCTS.aiavatar,
    isNew: true,
  },
  productHeroSectionProps: {
    heroPill: {
      category: HeroPillCategoryEnum_en.Products,
      subCategory: ProductsEnum_en.AiAvatar,
    },
    title: [
      {
        text: "Launch Your",
        lineBreak: true,
      },
      {
        text: "AI Avatar",
        highlight: true,
      },
    ],
    description:
    "Turn your expertise into 24/7 revenue with AI Avatar that tutors and engages— while you focus on creating.",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Create my AI Avatar",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.hero,
          },
  },
        queryParams: {
          destination: OnboardingDestinationEnum.Courses,
          skipOnboarding: false,
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.hero,
          },
        },
      },
    ],
    heroStatsProps: {
      text: "200,000+ happy creators",
      avatars: [
        {
          src: Avatar1,
          alt: "avatar1",
        },
        {
          src: Avatar2,
          alt: "avatar2",
        },
        {
          src: Avatar3,
          alt: "avatar3",
        },
      ],
    },
    coverImage: {
      src: getCDNURL().replace(/\/$/, '') + "/graphy-web/videos/AI_Launch.mp4",
      alt: "AiAvatars",
      isVideo: true
    },
  },
  productStepsSectionProps: {
    title: [
      {
        text: "Multiply Your Impact ",
        highlight: true,
      },
      {
        text: "Without Multiplying Your Hours",
        highlight: false,
      },
    ],
    description:
      "",
    steps: [
      {
        image: alwaysontutor,
        text: "Always-on Tutor",
        description:
          "Your Avatar answers course questions, explains topics/lessons, and guides the audience to completion — 24/7.",
      },
      {
        image: CardsAiAgent2,
        text: "Engage Audience",
        description:
        "Your Avatar can talk about anything — your story, your opinions, your industry insights — helping you build your personal brand.",
      },
      {
        image: montizeaccess,
        text: "Monetize Access",
        description:
          "Sell access as a one-time plan, subscription, or usage-based plan — or keep it free to boost engagement.",
      },
    ],
  },
  testimonyCarouselSectionProps: {
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
 },
  infoAccordionSection: {
    title: [
      {
        text: "How AI Avatar Transform Your Business",
      },
    ],
    amplitudeEvent: {
      eventName: LANDING_PAGE_EVENTS.PRODUCT_FEATURE_DETAIL_EXPANDED.LABEL,
    },
    section: InfoAccProdSecForAmpEnum.AiAvatars,
    cta: {
      type: ButtonTypeEnum.Secondary,
      size: ButtonSizeEnum.Regular,
      text: "Launch your AI Avatar",
      actionType: CtaActionType.SignUp,
      amplitudeEvent: {
        eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
        eventProperties: {
          source: SignUpSourceEnum.products_section,
        },
      },
      queryParams: {
        destination: OnboardingDestinationEnum.Courses,
        skipOnboarding: false,
      },
    },
    data: [
      {
        title: "Add Your Knowledge",
        description:
          "Upload your social media links, course notes, lessons, and FAQs.",
        image: {
          src: InfoAccordionaiavatarStep1,
          alt: "AiAvatars",
        },
      },
      {
        title: "Train Your AI Avatar",
        description:
          "We make it sound like you — with your tone and style.",
        image: {
          src: trainyouravatar,
          alt: "AiAvatars",
        },
      },
      {
        title: "Launch on dashboard",
        description:
        "Your tutor AI avatar will appear on the learner dashboard to assist learners with all kinds of course-related queries",
        image: {
          src: InfoAccordionaiavatarStep2,
          alt: "AiAvatars",
        },
      },
      {
        title: "Monetize",
        description:
          "Set pricing and start earning from every interaction.",
        image: {
          src: InfoAccordionaiavatarStep4,
          alt: "AiAvatars",
        },
      },
    ],
    type: InfoAccordionTypeEnum.MediaFirst,
  },
  successStoriesMarqueeSectionProps: {
    title: [
      {
        text: "Success Stories of Our Partners",
      },
    ],
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  faqSectionProps: {
    title: "FAQs",
    description:
      "Explore our help center for detailed information on selling courses, troubleshooting guides, and more",
    cta: CtaVisitHelpCentre_en,
    faqs: [
      {
        question:
          "How accurate is my AI Avatar?",
        answer:
          "Your AI Avatar learns from your content, so it answers just like you.",
      },
      {
        question:
          "Can I change the responses of my AI Avatar?",
        answer: "Yes — update your brain anytime and your AI Avatar will follow.",
      },
      {
        question:
          "How can I use AI Avatar to earn money?",
        answer:
          "You can monetize your AI Avatar by charging for access — either as a one-time plan, a monthly subscription, or on a per-session basis. Many creators use Tutor Avatars as a premium feature for paying learners, adding a new stream of recurring revenue to their business.",
      },
      {
        question: "issues AI Avatar customizable?",
        answer:
          "Absolutely. You control their tone of voice, the type of questions they answer, and what knowledge they have access to. You can update and retrain it anytime to reflect your latest content or offerings.",
      },
    ],
  },
  centreCtaSectionProps: {
    maxWidth: "max-w-[720px]",
    title: [
      {
        text: "Launch your first",
        highlight: false,
      },
      {
        text: "AI Avatar Today",
        highlight: true,
      },
    ],
    description:
      "Start monetizing engagement.",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Create my AI Avatar",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.body_end,
          },
        },
        queryParams: {
          destination: OnboardingDestinationEnum.Courses,
          skipOnboarding: false,
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.bodyEnd,
          },
        },
      },
    ],
  },
 };

 
export const productPagesData_en: ProductDataType[] = [
  CoursePageData,
  WebinarPageData,
  MembershipPageData,
  DigitalProductPageData,
  TelegramCommunityPageData,
  AiAvatar,
];

export const productPagesData_us: ProductDataType[] = [
  CoursePageData,
  WebinarPageData,
  MembershipPageData,
  DigitalProductPageData,
  AiAvatar,
];
